import { render } from "./MainDescribe.vue?vue&type=template&id=de7fbefa&scoped=true"
import script from "./MainDescribe.vue?vue&type=script&lang=js"
export * from "./MainDescribe.vue?vue&type=script&lang=js"

import "./MainDescribe.vue?vue&type=style&index=0&id=de7fbefa&scoped=true&lang=css"

import exportComponent from "D:\\eazyc\\ezDev\\ECS-Cognitive\\cognitive-screening-mobile-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-de7fbefa"]])

export default __exports__